import { type MetaDescriptor } from 'react-router';

import { createI18nFn } from 'i18n/createI18nFn';
import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardPartnerResourcesRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';
import type { HorizonRouteMetaArgs } from 'routing/types/HorizonRouteMetaArgs';

import { OrgDashboardIntegrationPartnerResourcesLoadable } from './OrgDashboardIntegrationPartnerResourcesLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  context,
}: HorizonAppRouteLoaderArgs<typeof orgDashboardPartnerResourcesRoute>) {
  await OrgDashboardIntegrationPartnerResourcesLoadable.load();

  return { locale: context.locale };
}

export function meta({
  loaderData: { locale },
}: HorizonRouteMetaArgs<typeof loader>): MetaDescriptor[] {
  const i18n = createI18nFn(locale);

  return [{ title: i18n('Partner Resources') }];
}

export default function OrgDashboardIntegrationPartnerResourcesRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardIntegrationPartnerResourcesLoadable />;
}
